import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.js"; // Add ".js" extension
// import Footer from "./footer.js";
// import Header from "./header.js";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
